import { useState } from "react";
import * as Scrivito from "scrivito";
import Panel from "./Panel";

function CollapseWidget({ widget }) {
  const [active, setActive] = useState(null);

  return (
    <Scrivito.WidgetTag className="collapse-widget">
      {widget.get("panels").map((panel, index) => (
        <Panel
          widget={panel}
          key={index}
          toggle={() => {
            setActive(active === panel.id() ? null : panel.id());
          }}
          isActive={panel.id() === active}
        />
      ))}
    </Scrivito.WidgetTag>
  );
}

Scrivito.provideComponent("CollapseWidget", CollapseWidget);
